<template>
    <div class="ListAnaliseRisco">
        <HeaderPage></HeaderPage>
        <el-card v-loading="loadingPage">
            <FilterBox v-on:filterExport="exportDados" :currentPage="listData.meta ? listData.meta.pagination.current_page : 1" />
        </el-card>
    </div>
</template>
  
  <script>
    import HeaderPage from '@/app/components/HeaderPage'
    import FilterBox from '@/app/domains/Report/components/AnaliseRisco/_filterBox'
    import { exportAnalysisRisk } from '@/app/domains/Report/services'
    
    export default {
        name: "ListAnaliseRisco",
        components: {
            HeaderPage,
            FilterBox,
        },
        data () {
            return {
                loadingPage: false,
                listData: {}
            }
        },
        methods: {
            openUrl(url){
                return window.open(url,'_blank')
            },
            async exportDados(query = '') {
                console.log(query);
                this.loadingPage = true
                try {
                    let response = await exportAnalysisRisk(query)
                    this.openUrl(response.data)
        
                } catch (e) {
                    this.$message({
                        showClose: true,
                        message: e.message,
                        type: 'error',
                    });
                } finally {
                this.loadingPage = false
                }
            }
        },
    }
  </script>
  
  <style scoped></style>
  